/**
 * The maximum portfolios availailable for free user
 */
export const _maxPortfolioLimit = 3;

/**
 * The maximum portfolios availailable for a verified user
 */
export const _verifiedUserMaxPortfolioLimit = 10;

/**
 * The maximum decimal displayed for operation quantity
 */
export const _operationQuantityMaxDecimals = 4;
